export default "__VITE_ASSET__R1A0u9pI__"